import type { AwsUploadRequestApiResponse } from "@/Modules/Chat/Models/Api/Chat";
import { hasValue } from "@/Utils/Objects";
import axios from "axios";

export type ProgressFunction = (a: number) => void;

class AwsFileConnector {
  public awsUploadFile(
    awsUploadRequestResponse: AwsUploadRequestApiResponse,
    file: File | Blob | null,
    onUploadProgress: ProgressFunction
  ) {
    const formData = new FormData();
    if (file) {
      formData.append("key", awsUploadRequestResponse.path);
      formData.append("AWSAccessKeyId", awsUploadRequestResponse.aws_access_key);
      formData.append("acl", awsUploadRequestResponse.acl);
      formData.append("policy", awsUploadRequestResponse.policy);
      formData.append("signature", awsUploadRequestResponse.signature);
      formData.append("Content-Type", file.type);
      formData.append("file", file);
    }

    return axios.post(awsUploadRequestResponse.url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        if (hasValue(progressEvent.total)) {
          const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);

          onUploadProgress(progress);
        }
      },
    });
  }
}

export default AwsFileConnector;
